import { Observable } from 'rxjs';
import { IRemoveRoomMemberOutput, RemoveRoomMemberInput } from 'src/app/core/chat/usecase/member/member-remove-socket-use-case.service';

export abstract class IMemberSocketRepository {
  abstract removeMember(input: RemoveRoomMemberInput): Promise<any>

  abstract listenToRemoveMember(): Observable<IRemoveRoomMemberOutput>
}
